// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.bulletList[data-v-04132d06] {\n  font-size: 0.9rem;\n}\n.darkTheme .modal-content[data-v-04132d06] {\n  color: #dddddd !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
